import React from 'react';
import { Box, Typography } from '@mui/material';

const ReportsPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Reports & Analytics</Typography>
      <Typography variant="body1">Reports and analytics functionality will be implemented here.</Typography>
    </Box>
  );
};

export default ReportsPage; 